import PickEligibility from './PickEligibility';

// For years with a dynamically-synced schedule (2026+), the backend now returns
// each game's real deadline as an ISO UTC timestamp directly in the `deadlines`
// array instead of a hand-typed deadline-type token (e.g. 'tnf', 'normal') --
// so eligibility is just a plain date comparison against server-provided truth,
// no client-side hardcoded date tables needed. For historical years (2022-2025)
// `deadline` is still the legacy token, so this falls back to the existing
// PickEligibility/GetTargetDate hardcoded-date-table logic completely unchanged.
function looksLikeIsoTimestamp(deadline) {
    return typeof deadline === 'string' && deadline.includes('T') && !isNaN(new Date(deadline).getTime());
}

// PickEligibility/GetTargetDate have real branches only for 2022-2024, plus an
// unlabeled fallback block hardcoded to the *2025* season's actual dates -- for
// 2026+, calling them with a non-ISO deadline (e.g. 'normal') doesn't mean
// "this is a legacy year," it means "the real per-game deadline for this
// dynamically-scheduled year just hasn't loaded from the server yet." Silently
// computing against 2025's dates in that window is worse than just waiting: it
// shows a real (if stale) day of the week/month, so it reads as ground truth
// instead of a loading state. Treat 2026+ as always eligible until real data
// arrives, rather than ever falling through to the pre-2026 tables.
function IsEligible(weekNum, deadline, year) {
    if (looksLikeIsoTimestamp(deadline)) {
        return Date.now() < new Date(deadline).getTime();
    }
    if (Number(year) >= 2026) {
        return true;
    }
    return PickEligibility(weekNum, deadline, year);
}

export default IsEligible;
